module.exports = __webpack_public_path__ + "static/Q7Answer6_Rollercoaster_BradleyPisney-8f897b9fb2658c0bca029e020d4a9e52.jpg";